function getDevice() {
	if (navigator.userAgent.match(/Tablet|iPad/i)) {
		return 'Tablet';
	}
	if (navigator.userAgent.match(/mobile/i)) {
		return 'Mobile';
	}
	return 'Desktop';
}

export default getDevice;
